import React from "react";
import { Loader } from "./Loader";
import classNames from "classnames";

export default function LogoutOverlay() {
  return (
    <div className="logout-overlay-content">
      <Loader />
      <p className={classNames("title-sm", "logout-overlay-text")}>
        {wattpad.utils.trans("Logging out...")}
      </p>
    </div>
  );
}
